import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-1"}]]

const IconNumber10Small = createReactComponent('outline', 'number-10-small', 'Number10Small', __iconNode);

export default IconNumber10Small;